import { Card, Col, List, Row, Skeleton, Space } from "antd";
import React, { useEffect } from "react";

import {
  DropDown,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import styles from "./yourVendors.module.css";
import Meta from "antd/es/card/Meta";

import img1 from "../../../../assets/staticImages/photoimg1.png";
import img2 from "../../../../assets/staticImages/photoimg2.png";
import img3 from "../../../../assets/staticImages/photoimg3.png";
import img4 from "../../../../assets/staticImages/photoimg4.png";
import img5 from "../../../../assets/staticImages/vendorimg5.png";
import img6 from "../../../../assets/staticImages/vendorimg6.png";
import img7 from "../../../../assets/vendorimg6.png";
import img8 from "../../../../assets/vendorimg7.png";
import img9 from "../../../../assets/staticImages/photoimg2.png";
import dummyImg from "../../../../assets/dummy.jpg";
import { useState, memo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { VendorMiddleware } from "../../../../Store/Middlewares/VendorMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { roles } from "../../../../config/roles";
import Storage from "../../../../utills/AsyncStorage";

const RenderItem = memo(({ item, loader, event_id, key }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  return (
    <List.Item key={item?.id}>
      {loader ? (
        <Space
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginTop: "10px",
          }}
        >
          <Skeleton.Image active className={styles.image} />
          <Skeleton.Input active size={20} />
        </Space>
      ) : (
        <Card
          hoverable
          style={{ width: "100%" }}
          cover={
            <img
              className={styles.image}
              src={item.image ? item?.image : dummyImg}
              alt="example"
            />
          }
          onClick={() => {
            navigate("/findVendors/VendorDetails", {
              state: {
                headrTitle: "Vendors",
                data: item,
                eventData: state?.eventData,
              },
            });
          }}
        >
          <Meta
            style={{ textAlign: "center" }}
            title={<TextComponent text={item?.name} />}
            // description="www.instagram.com"
          />
          <Row className={styles.avenueText}>
            <TextComponent
              textClass={styles.avenueText}
              text={
                item?.service_category_name ? item?.service_category_name : "--"
              }
            />
          </Row>
          {/* <TextComponent textClass={styles.descText} text={item.des} /> */}
        </Card>
      )}
    </List.Item>
  );
});
const data = [0, 1, 2, 3];

const YourVendors = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const EventCategory = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes?.servicecategory,
  );
  const YourVendorList = useSelector(
    (state) => state?.VendorReducer?.YourVendors,
  );
  const YourVendorListPagination = useSelector(
    (state) => state?.VendorReducer?.YourVendorsPagination,
  );
  // console.log("searchhh", search);
  const event_id = state?.eventData?.id;
  const [category, setCategory] = useState();
  const [loader, setloader] = useState(false);
  console.log("state===>>>>>>", YourVendorList);
  const role = Storage.getERole("@role");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let data = {
      event_id: event_id,
      category_id: undefined,
      vendor_name: search,
      next_page_url: undefined,
    };
    dispatch(VendorMiddleware.getYourVendors(data))
      .then(() => setloader(false))
      .catch(() => setloader(false));
  };
  const onSearchVendor = () => {
    if (!category?.id && !search) {
      dispatch(
        showAlert({
          type: "Warning",
          message: "Please select category and enter vendor name",
        }),
      );
    } else {
      // setSearch(e)
      setloader(true);
      let data = {
        event_id: event_id,
        category_id: category?.id,
        vendor_name: search,
        next_page_url: undefined,
      };
      dispatch(VendorMiddleware.getYourVendors(data))
        .then(() => setloader(false))
        .catch(() => setloader(false));
    }
  };
  const onPressRenderMoreContent = () => {
    let data = {
      event_id: event_id,
      category_id: category?.id,
      vendor_name: search,
      next_page_url: YourVendorListPagination?.links?.next,
    };
    dispatch(VendorMiddleware.getYourVendors(data))
      .then(() => setloader(false))
      .catch(() => setloader(false));
  };
  return (
    <>
      <Row className={styles.searchContainer}>
        <Col className={styles.category}>
          <DropDown
            placeholder={"Category"}
            onChange={(e) => setCategory(e)}
            object={EventCategory}
          />
        </Col>
        <Col className={styles.search}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col className={styles.category}>
          <SubmitButton title="Search" onClick={onSearchVendor} />
        </Col>
      </Row>
      {role === roles.client ? (
        <SubmitButton
          title="Invite Vendor"
          onClick={() =>
            navigate("/findVendors/AddVendors", {
              state: { headrTitle: "Invite Vendor", event_id },
            })
          }
        />
      ) : null}
      <Row className={styles.textCont}>
        <TextComponent
          textClass={styles.text}
          text="Vendors added to your event listed here, Find more vendors to plan better!"
        />
      </Row>
      <List
        grid={{
          xs: 1,
          sm: 2,
          md: 2,
          lg: 3,
          xl: 4,
          xxl: 4,
        }}
        dataSource={loader ? data : YourVendorList}
        renderItem={(item) => (
          <RenderItem
            item={item}
            loader={loader}
            event_id={event_id}
            footer={
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {YourVendorListPagination?.links?.next != null ? (
                  <div style={{ width: "50%" }}>
                    <SubmitButton
                      title={"Load More"}
                      onClick={onPressRenderMoreContent}
                    />
                  </div>
                ) : null}
              </div>
            }
          />
        )}
      />
    </>
  );
};

export default YourVendors;
